import { BorderDottedIcon } from "@radix-ui/react-icons";

import { Button } from "@/components/atoms/Button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/atoms/DropDown";
import type { IEditDeleteDropDownProps } from "@/components/molecules/Review/types";
import { useTranslations } from "@/hooks/common/useTranslations";

const EditDeleteDropDown = ({ onEdit, onDelete }: IEditDeleteDropDownProps) => {
  const { t } = useTranslations("SingleAppPage");

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild className="cursor-pointer">
        <Button variant="ghost" size="icon" className="max-sm:w-6 max-sm:h-6">
          <BorderDottedIcon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" forceMount>
        <DropdownMenuItem onClick={onEdit}>Edit</DropdownMenuItem>
        <DropdownMenuItem
          className=" text-red-600 hover:text-red-600"
          onClick={onDelete}
        >
          {t("delete")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default EditDeleteDropDown;
